import { selectPlaceholderNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';

const KRC_DISCIPLINE_CONTAINER: BuildingBlockNodeConfig = {
  nodeSelector: selectPlaceholderNode,
  information: {
    single: 'Disciplines',
    plural: 'Disciplines',
  },
  buildingBlocks: [{ type: NodeType.KRC_CURRICULUM_DISCIPLINE }],
  edit: [],
  showPlaceholder: true,
  readOnlyNode: true,
  isNotDraggable: true,
  isNotDeletable: true,
  isCollapsible: true,
  onNewNodeDropped: {
    openAside: false,
  },
};

export default KRC_DISCIPLINE_CONTAINER;
